import { createFileRoute, Link } from "@tanstack/react-router";
import { AppHeader } from "../components/AppHeader";
import { t } from "../i18n/en";
import { pageHead } from "../utils/page-title";

export const Route = createFileRoute("/privacy")({
  head: () => pageHead("Privacy Policy", { canonicalPath: "/privacy" }),
  component: PrivacyPage,
});

function PrivacyPage() {
  return (
    <main className="relative mx-auto w-full max-w-3xl px-4 py-10 sm:px-6 sm:py-14">
      <AppHeader />
      <section className="rounded-[2rem] border-[3px] border-black bg-white p-6 shadow-[10px_10px_0_#95A789] sm:p-8">
        <p className="font-mono-display text-xs font-bold uppercase tracking-[0.08em] text-[#6f8065]">
          Harness
        </p>
        <h1 className="harness-page-title mt-3 font-display font-bold lowercase text-black">
          {t("ui.copy_privacy_policy_31f3ec6f")}
        </h1>
        <div className="mt-6 space-y-5 text-[15px] leading-relaxed text-black/70 sm:text-lg">
          <p>{t("ui.copy_harness_collects_the_email_address_y_835d7780")}</p>
          <p>{t("ui.copy_marketing_email_is_separate_and_opti_5de9ea1b")}</p>
          <p>{t("ui.copy_we_do_not_sell_your_email_address_yo_4049faca")}</p>
          <p>{t("ui.copy_harness_uses_the_birth_details_you_e_a7ea78b2")}</p>
          <p>{t("ui.copy_access_to_a_saved_chart_library_requ_3f40d5ae")}</p>
          <p>{t("ui.copy_you_should_enter_birth_details_only_a553b7bf")}</p>
          <p>
            {t("ui.copy_questions_about_privacy_can_be_sent_773e1fc0")}{" "}
            <a
              href="mailto:harness@megszurgot.com"
              className="font-semibold text-black underline decoration-[3px] underline-offset-4 transition hover:text-[#6f8065]"
            >
              {t("ui.copy_harness_megszurgot_com_f54a99fd")}
            </a>
            .
          </p>
        </div>
        <p className="mt-8">
          <Link
            to="/"
            className="rounded-full border-2 border-black px-5 py-3 text-sm font-bold uppercase tracking-[0.12em] text-black transition hover:bg-black hover:text-white"
          >
            {t("common.backHome")}
          </Link>
        </p>
      </section>
    </main>
  );
}
